"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _functions = require("../../utils/functions");

var menuRowIndex = 0;
var MENU_WIDTH_BUFFER = 200;

var getMenuRowIndex = function getMenuRowIndex() {
  return menuRowIndex++;
};

var MoreMenuContent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MoreMenuContent, _Component);

  function MoreMenuContent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MoreMenuContent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MoreMenuContent).call(this, props));

    _this.setMenu = function () {
      var _this$props = _this.props,
          toolbarWidth = _this$props.toolbarWidth,
          onOpenComplete = _this$props.onOpenComplete,
          menuItems = _this$props.menuItems;

      var menuWidth = _this.node.getBoundingClientRect().width;

      var menu = menuWidth > toolbarWidth - MENU_WIDTH_BUFFER ? _this.splitMenus(menuItems) : [menuItems];

      _this.setState({
        menu: menu
      }, onOpenComplete);
    };

    _this.splitMenus = function (menuItems) {
      var half = Math.floor(menuItems.length / 2);
      return [menuItems.slice(0, half), menuItems.slice(half)];
    };

    _this.renderControl = function (_ref, itemIndex) {
      var name = _ref.name,
          renderControl = _ref.renderControl;
      return _react.default.createElement("div", {
        className: itemIndex > 0 ? 'm-left-2' : '',
        key: "more-" + name
      }, renderControl());
    };

    _this.renderMenuRow = function (row, index) {
      var className = '';

      if (index > 0) {
        className = 'm-top-2';
      }

      return _react.default.createElement(_UIFlex.default, {
        className: className,
        key: "menu-row-" + getMenuRowIndex(),
        align: "center"
      }, row.map(_this.renderControl));
    };

    _this.splitMenus = (0, _functions.memoize)(_this.splitMenus, function (menuItems) {
      return menuItems.length;
    });
    _this.state = {
      menu: [props.menuItems]
    };
    return _this;
  }

  (0, _createClass2.default)(MoreMenuContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMenu();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.menuItems.length !== this.props.menuItems.length) {
        this.setMenu();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        ref: function ref(node) {
          return _this2.node = node;
        },
        className: "p-x-4 p-y-2"
      }, this.state.menu.map(this.renderMenuRow));
    }
  }]);
  return MoreMenuContent;
}(_react.Component);

exports.default = MoreMenuContent;
MoreMenuContent.propTypes = {
  menuItems: _react.PropTypes.array.isRequired,
  toolbarWidth: _react.PropTypes.number.isRequired,
  onOpenComplete: _react.PropTypes.func
};
module.exports = exports.default;